import SEO from '../components/SEO';
import React from 'react';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="Terms & Conditions | Ascarii"
        description="Terms and conditions for Ascarii services, SAP Business One implementation, cloud hosting, and support services."
        keywords="terms and conditions, legal terms, service agreement"
      />

      <section className="py-20 bg-gradient-to-br from-blue-600 via-sky-700 to-cyan-600">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">Terms & Conditions</h1>
            <p className="text-xl text-blue-100">Please read these terms carefully before using our website</p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8 max-w-4xl">
          <div className="prose prose-lg max-w-none">
            <div className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 border border-gray-200 mb-8">
              <p className="text-gray-700 leading-relaxed">These terms and conditions apply between you, the User of this Website, and Ascarii Limited. Your agreement to comply with these terms is deemed to occur upon your first use of the Website.</p>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Intellectual Property and Acceptable Use</h2>
            <p className="text-gray-700 mb-4">All Content included on the Website is the property of Ascarii Limited, our affiliates or other relevant third parties. Content is protected by copyright, trademarks, database rights and other intellectual property rights.</p>
            <p className="text-gray-700 mb-4">You may retrieve, display and view the Content on a computer screen for your own personal, non-commercial use only. You must not reproduce, modify, copy, distribute or use for commercial purposes any Content without written permission.</p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Prohibited Use</h2>
            <p className="text-gray-700 mb-4">You may not use the Website in any way which:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Causes damage to the Website or interferes with others' use</li>
              <li>Is harmful, unlawful, illegal, abusive, harassing, or threatening</li>
              <li>Makes unauthorised copies of copyrighted Content</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Links to Other Websites</h2>
            <p className="text-gray-700 mb-4">This Website may contain links to other sites not under our control. We assume no responsibility for their content and disclaim liability for any loss arising from their use.</p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Privacy Policy</h2>
            <p className="text-gray-700 mb-4">Use of the Website is governed by our Privacy Policy. <a href="/privacy-policy" className="text-blue-600 hover:underline">View Privacy Policy</a></p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Limitation of Liability</h2>
            <p className="text-gray-700 mb-4">To the maximum extent permitted by law, Ascarii Limited accepts no liability for:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Any business losses including profits, revenue, or anticipated savings</li>
              <li>Loss or corruption of data or software</li>
              <li>Any special, indirect or consequential loss or damage</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">General</h2>
            <p className="text-gray-700 mb-4">These terms may be varied by us from time to time. These terms are governed by English law and subject to the exclusive jurisdiction of English courts.</p>

            <div className="bg-blue-50 rounded-xl p-6 border border-blue-200 mt-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Ascarii Limited Details</h3>
              <p className="text-gray-700 mb-2">Company Number: 07970532</p>
              <p className="text-gray-700 mb-2">Registered Address: NetPark Plexus, Thomas Wright Way, Sedgefield, County Durham, TS21 3FD</p>
              <p className="text-gray-700 mb-2">VAT Number: GB160449712</p>
              <p className="text-gray-700">Contact: <a href="mailto:info@ascarii.com" className="text-blue-600 hover:underline">info@ascarii.com</a></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
